var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{style:({color: _vm.color})},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('img',{attrs:{"src":require("../../assets/logo.png"),"alt":""}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("主要按钮")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-76e8c0d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/packages/hello-world/moor-hello-world.vue
// module id = 165
// module chunks = 0